import { render, staticRenderFns } from "./VendasStatus.vue?vue&type=template&id=3acac7f1&"
import script from "./VendasStatus.vue?vue&type=script&lang=js&"
export * from "./VendasStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports